import { BagPersonalTagOutlineIcon } from './BagPersonalTagOutlineIcon';

/**
 * author: Matthew Terry
 * id 49BAA4CB-38E1-4792-93ED-8298AFB304A1
 * name bag-personal-tag-outline
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-personal-tag-outline.svg
 * tags
 */
export const PropertyTagOutlineIcon = BagPersonalTagOutlineIcon;
export default PropertyTagOutlineIcon